<template>
  <Transition name="lf-cookie">
    <aside
      v-if="showBanner"
      class="lf-cookie"
      role="dialog"
      aria-live="polite"
      aria-label="Aviso de cookies"
    >
      <div class="lf-cookie__inner">
        <div class="lf-cookie__text">
          <strong>Cookies</strong>
          <p>
            Usamos cookies para mejorar tu experiencia.
            <router-link to="/politica-cookies">Más información</router-link>
          </p>
        </div>

        <div class="lf-cookie__actions">
          <button class="lf-btn lf-btn--ghost lf-cookie__btn" @click="reject">
            Solo esenciales
          </button>
          <button class="lf-btn lf-btn--ghost lf-cookie__btn" @click="customize">
            Personalizar
          </button>
          <button class="lf-btn lf-btn--primary lf-cookie__btn" @click="accept">
            Aceptar todas
          </button>
        </div>
      </div>
    </aside>
  </Transition>
</template>

<script>
export default {
  name: 'CookieBanner',
  emits: ['cookies-accepted', 'open-settings'],
  data() {
    return {
      showBanner: false
    }
  },
  mounted() {
    const consent = localStorage.getItem('cookieConsent')
    if (!consent) {
      // pequeño delay para no atacar al usuario al cargar
      setTimeout(() => { this.showBanner = true }, 800)
    }
  },
  methods: {
    accept() {
      this.save('all')
    },
    reject() {
      this.save('essential')
    },
    customize() {
      this.showBanner = false
      this.$emit('open-settings')
    },
    save(type) {
      localStorage.setItem('cookieConsent', type)
      localStorage.setItem('cookieConsentDate', new Date().toISOString())
      this.showBanner = false
      this.$emit('cookies-accepted', type)
    }
  }
}
</script>

<style scoped>
.lf-cookie {
  position: fixed;
  left: 50%;
  bottom: 24px;
  transform: translateX(-50%);
  width: min(920px, calc(100vw - 32px));
  background: var(--lf-surface);
  border: 1px solid var(--lf-border-2);
  border-radius: 14px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
  z-index: 1000;
  padding: 18px 22px;
  backdrop-filter: blur(12px);
}

.lf-cookie__inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}

.lf-cookie__text {
  flex: 1;
  min-width: 0;
}
.lf-cookie__text strong {
  display: block;
  font-size: 13.5px;
  color: var(--lf-text);
  margin-bottom: 2px;
}
.lf-cookie__text p {
  margin: 0;
  font-size: 13px;
  color: var(--lf-text-mute);
  line-height: 1.5;
}
.lf-cookie__text a {
  color: var(--lf-accent);
  text-decoration: underline;
  text-underline-offset: 2px;
}

.lf-cookie__actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}
.lf-cookie__btn {
  padding: 10px 16px;
  font-size: 13.5px;
  border-radius: 999px;
}

/* Transición */
.lf-cookie-enter-active,
.lf-cookie-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}
.lf-cookie-enter-from,
.lf-cookie-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(20px);
}

/* Responsive */
@media (max-width: 720px) {
  .lf-cookie { padding: 16px; }
  .lf-cookie__inner {
    flex-direction: column;
    align-items: stretch;
    gap: 14px;
  }
  .lf-cookie__actions {
    flex-direction: column-reverse;
  }
  .lf-cookie__btn { width: 100%; }
}

@media (prefers-reduced-motion: reduce) {
  .lf-cookie-enter-active,
  .lf-cookie-leave-active { transition: none; }
}
</style>